<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="items.length===0"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        hide-default-footer dense
        style="white-space: nowrap">
      <template v-slot:top v-if="toolbar">
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn @click="row_create" small class="ma-2" color="primary">New</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>
      <template v-slot:item.workers="{item}">
        <v-label>{{ getWorkersLabel(item) }}</v-label>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small>mdi-content-copy</v-icon>
        <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-job-config-dialog ref="dialog"/>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {JobConfig} from "@/modules/redactor/models/worker/jobs/JobConfig";
import RJobConfigDialog from "@/modules/redactor/views/worker/r-job-config-dialog";

export default {
  name: "r-job-config-table",
  components: {RJobConfigDialog},
  props: {
    title: VueTypes.string.def("Config"),
    items: VueTypes.arrayOf(JobConfig),
    toolbar: VueTypes.bool.def(true)
  },
  data: () => ({
    headers: [
      {text: 'Worker', value: 'workers'},
      {text: 'Tasks', value: 'tasks.length', sortable: false},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  methods: {
    row_copy(item) {
      this.items.push(item.copy());
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            const index = this.items.indexOf(item);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    },
    row_moveup(item) {
      const index = this.items.indexOf(item);
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.items.indexOf(item);
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    },

    getWorkersLabel(item) {
      if (item.workers.length === 1 && item.teams.length === 0) {
        return item.workers[0].label;
      } else if (item.workers.length === 0 && item.teams.length === 1) {
        return item.teams[0].name;
      } else {
        let count = item.teams.reduce((count, team) => {
          return count + team.workers.length;
        }, item.workers.length);
        return "CUSTOM (" + count + ")";
      }
    }
  }
}
</script>